import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IErrorInfo } from './components/manager/contracts/error-info';
import { ModalFormStatus } from './components/manager/contracts/modal-form-status';
import { ModalButtonSet } from './components/manager/contracts/modal-buttons';
import { IState } from './components/manager/contracts/state';
import { ModalFormHostManager } from './components/manager/modal-form-host-manager';
import { ModalFormHostComponent } from './components/modal-form-host/modal-form-host.component';
import { ModalFormHostModule } from './components/modal-form-host/modal-form-host.module';
import { ModalFormHostServiceModule } from './services/modal-form-host-service/modal-form-host-service.module';
import { ModalFormHostService } from './services/modal-form-host-service/modal-form-host.service';

@NgModule({
    imports: [
        CommonModule,
        ModalFormHostModule,
        ModalFormHostServiceModule
    ],
    exports: [
        ModalFormHostModule,
        ModalFormHostServiceModule
    ]
})
export class CucurbItNgxBootstrapModalHostModule {}

export {
    IState,
    ModalFormHostManager,
    ModalFormHostService,
    ModalButtonSet,
    ModalFormStatus,
    IErrorInfo,
    ModalFormHostComponent
};
